// extracted by mini-css-extract-plugin
module.exports = {"field":"SendMessage_field__kdL5k","container":"SendMessage_container__9Qvz5","button":"SendMessage_button___0b6O"};